import { CategoryTile } from "./CategoryTile";
import { Grid, GridItem } from "@ecco/ui/grid";
import type { NavigationLink } from "@lib/contentful/mappers/mapNavigation";
import type { FC } from "react";
import { innerNavLeftGridStyles } from "@components/layouts/navigation/styles";

interface IThumbnailGrid {
    thumbnailLinks: NavigationLink[];
    isVisible?: boolean;
}

export const ThumbnailGrid: FC<IThumbnailGrid> = ({ thumbnailLinks, isVisible = false }) => {
    if (thumbnailLinks.length === 0) {
        return null;
    }

    return (
        <Grid
            sx={innerNavLeftGridStyles}
            templateColumns={{
                lg: "repeat(2, 1fr)",
                xl: "repeat(2, 1fr)",
            }}
            pr={{ base: 2, xl: 3 }}
        >
            {thumbnailLinks.map((link) => (
                <GridItem w="100%" key={link.id}>
                    <CategoryTile
                        isLeftSide={true}
                        link={link}
                        imageSizes={["50vw", "50vw", "25vw", "25vw"]}
                        isVisible={isVisible}
                    />
                </GridItem>
            ))}
        </Grid>
    );
};
